import { Currency } from 'core/payments/entities';

export enum TaboolaEventName {
  PAGE_VIEW = 'PageView',
}

export enum AppnebulaTaboolaEventName {
  SIGN_UP = 'complete_registration',
  PURCHASE = 'make_purchase',
  SCAN_VIEW = 'scan_view',
}

export type TaboolaPaymentData = {
  currency: Currency;
  ltvPredict: number;
  orderId: string;
};

export type TaboolaMethods = {
  revokeConsentEu: () => void;
  revokeConsentUs: () => void;
  grantConsentEu: () => void;
  grantConsentUs: () => void;
  track: (name: string, params?: Record<string, unknown>) => void;
};
